var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import uid from 'uid';
import { graphql } from 'react-apollo';
var isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
export var getUserAnalyticsGql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      query {\n        userAnalytics @rest(type: \"UserAnalytics\", path: \"/user-analytics", "\", endpoint: \"query\") {\n          id\n          videosWatched\n          pagesVisited\n        }\n      }\n    "], ["\n      query {\n        userAnalytics @rest(type: \"UserAnalytics\", path: \"/user-analytics", "\", endpoint: \"query\") {\n          id\n          videosWatched\n          pagesVisited\n        }\n      }\n    "])), isIE ? "?randID=" + uid() : '');
export var getUserAnalyticsData = function () {
    return graphql(getUserAnalyticsGql, {
        options: {},
        props: function (_a) {
            var data = _a.data;
            return ({
                getUserAnalyticsQuery: data,
            });
        },
    });
};
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/queries/getUserAnalytics.ts
// module id = 812
// module chunks = 81